import { guideList } from "../../utils/policyUtils";
import React from "react";
import { useMembership } from "../../hooks/MembershipProvider/MembershipProvider";
import useAndroidBridge from "../../hooks/useAndroidBridge";
import { useLocation, useNavigate } from "react-router-dom";

const Guide = () => {
  const { isEmbed } = useMembership();
  const { sendToAndroid } = useAndroidBridge();
  const navigate = useNavigate();
  const loaction = useLocation();

  const goBack = () => {
    let { search } = loaction;
    if (search) {
      sendToAndroid("go-to-page", "mystate");
    } else {
      navigate(-1);
    }
  };
  return (
    <>
      {isEmbed() && (
        <div className={`mobile_app_header !bg-[#F0EEEA] !justify-end`}>
          <button onClick={goBack} className={`btn btn_close`}></button>
          {/*<p className={`mobile_app_header_text`}>내 정보</p>*/}
        </div>
      )}
      <div className={`content_wrap guide`}>
        <div className={`section_wrap sec_wrap_1`}>
          <div className={`sec sec_1`}>
            <h3 className={`text-center h3`}>자서전 제작 과정 자세히 보기</h3>
            <div className={`table_box`}>
              <table className={`table rounded-xl overflow-hidden`}>
                <thead className={``}>
                  <tr className={`text-center`}>
                    <th>
                      <p className={`md:hidden`}>순서</p>
                      <p className={`max-md:hidden`}>진행 순서</p>
                    </th>
                    <th>진행 상태</th>
                    <th>소요 기간</th>
                    <th className={`max-md:hidden`}>설명</th>
                  </tr>
                </thead>
                <tbody>
                  {guideList?.map((obj: any, idx: any) => {
                    return (
                      <tr key={idx}>
                        <td className={`text-center`}>{obj?.step}</td>
                        {/* orangeYn이 true인 경우 오렌지색으로 표시 */}
                        <td
                          className={`${
                            obj?.orangeYn === "true" && "orange"
                          } text-center`}
                        >
                          {obj?.state()}
                        </td>
                        <td className={`text-center`}>{obj?.date}</td>
                        <td className={`max-md:hidden`}>{obj?.desc()}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div className={`mt-5`}>
              <p className={`caption mb-2`}>
                *상품별로 정해진 이용 기간 내에 전자책 신청, 실물책 신청을
                완료해 주세요.
              </p>
              <p className={`caption mb-2`}>
                *소요 기간은 상황에 따라 달라질 수 있습니다.
              </p>
              <p className={`caption`}>
                *나의 현재 진행 상황은 [웹-마이페이지], [앱-메뉴-스토리북
                현황]에서 확인할 수 있습니다.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Guide;
